module.exports = __webpack_public_path__ + "static/media/appoptics-logo.d2015cc7.svg";